import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { CommonService } from '@app/services/common.service';
import { EventViewerService } from '@app/services/event-viewer.service';
import { EventsService } from '@app/services/events.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '@app/directives/base-component';

import { Helper } from 'src/4services/2helper';

@Component({
    selector: 'log_box_disarmed_event',
    templateUrl: './disarmed-event.component.html',
    styleUrls: ['../../../common.scss', '../../c_card_event_viewer_time_line.component.scss'],
    standalone: false
})
export class log_box_disarmed_event_component extends BaseComponent {
  @Input() log;
  @Input() timezone;

  snapshotPermission = false;
  isBrokenImage = false;
  isShowPlayBtn = false;
  isLoadingVideo = false;
  isShowVideo = false;

  constructor(
    public commonService: CommonService,
    private eventViewerService: EventViewerService,
    private sanitizer: DomSanitizer,
    private eventsService: EventsService,
    private helper: Helper,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  private snapshotPermission$w: Subscription;
  watch() {
    this.snapshotPermission$w = this.eventViewerService.snapshotPermission$w.subscribe((v) => this.snapshotPermission = v);
  }
  unwatch() {
    this.snapshotPermission$w?.unsubscribe();
  }

  async ngOnInit(){
    this.watch()
    if(this.log.imageUrl) this.safeBlobUrl()  
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.unwatch()
  }

  // --------------------------------
  // IMAGE / VIDEO
  safeBlobUrl() {
    const url = this.log.imageUrl?.changingThisBreaksApplicationSecurity
    if(!url) return
    this.log.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
  }

  computedBackground(){
    if(!this.snapshotPermission) return 'no-permission'

    if(!this.isShowVideo) {
      if(this.canIShowImage() === 'need to upgrade plan') return 'no-permission'
      if(this.canIShowImage() === 'expired') return 'no-permission'
      if(this.canIShowImage() === 'privacy mode') return 'no-permission'
      if(this.canIShowImage() === 'broken image') return 'no-permission'
      if(this.canIShowImage() === 'image') return 'full-height'
      if(this.canIShowImage() === 'default') return 'disarmed-event'
    } else {
      if(this.canIShowVideo() === 'need to upgrade plan') return 'no-permission'
      if(this.canIShowVideo() === 'expired') return 'no-permission'
      if(this.canIShowVideo() === 'privacy mode') return 'no-permission'
      if(this.canIShowVideo() === 'broken video') return 'no-permission'
      if(this.canIShowVideo() === 'video') return 'full-height'
      if(this.canIShowVideo() === 'default') return 'disarmed-event'
    }
  }

  canIShowImage(){
    const highestPlan = this.helper.dealer_plan.isPremiumPlan() || this.helper.dealer_plan.isResellerPlan()
    if(!this.snapshotPermission) return 'no permission'
    if(highestPlan && this.log.is_expired) return 'expired'
    if(!highestPlan && this.log.is_expired) return 'need to upgrade plan'
    if(this.log.isPrivacy) return 'privacy mode'
    if(this.isBrokenImage) return 'broken image'
    if(this.log.imageUrl) return 'image'
    return 'default'
  } 
  canIShowVideo(){
    const highestPlan = this.helper.dealer_plan.isPremiumPlan() || this.helper.dealer_plan.isResellerPlan()
    if(!this.snapshotPermission) return 'no permission'
    if(highestPlan && this.log.is_expired) return 'expired'
    if(!highestPlan && this.log.is_expired) return 'need to upgrade plan'
    if(this.log.isPrivacy) return 'privacy mode'
    if(this.log.videoUrl && !this.log.safetyVideoUrl) return 'broken video'
    if(this.log.safetyVideoUrl) return 'video'
    return 'default'
  } 

  toggleToVideo(e){
    e.stopPropagation()
    if(!this.log.videoUrl) return

    this.isShowVideo = !this.isShowVideo
    if(this.isShowVideo) {
      this.log.isLoading = true
      this.getMP4Video(this.log, this.log.videoUrl)
    }
  }

  mouseOverImage(e){
    e.stopPropagation();
    if(!this.log.videoUrl) return
    this.isShowPlayBtn = true
  }
  mouseLeaveImage(e){
    e.stopPropagation();
    if(!this.log.videoUrl) return
    this.isShowPlayBtn = false
  }

  imgLoaded(){
    let urlCreator = window.URL;
    urlCreator.revokeObjectURL(this.log.imageUrl)
  }

  imgError(err){
    this.isBrokenImage = true
    let urlCreator = window.URL;
    urlCreator.revokeObjectURL(this.log.imageUrl)
  }

  async getMP4Video(log, url) {
    let urlCreator = window.URL;
    try {
      const res = await lastValueFrom(this.eventsService.getSnapshotFromUrl(url))
      console.log(res, this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(res)))
      log['safetyVideoUrl'] = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(res));
      log.isLoading = false 
      this.cdr.detectChanges();  // 변경감지 수행
    } catch(err) {
      log.isLoading = false 
    }
  }
  
  // -------------------------------------------------------
  // COMMON
  parseWarningLog() {
    let isWarning = false;
    if (this.log.is_send_xml_signal === 2) {
      isWarning = true;
    }
    if (this.log.status) {
      if (this.log.status > 300) {
        isWarning = true;
      }
    } else {
      isWarning = true;
    }
    return isWarning;
  }

  isVideoAI(){
    const trigger = this.log.trigger.toLowerCase()
    return trigger.includes('videoai') ? true : false
  }

  isShowEntryEventBadge(){
    // Entry Event in AI analize
    if(!this.isVideoAI()) return false;
    let meta = null;
    try {
      meta = JSON.parse(this.log.meta)?.req;
    } catch(err){
      meta = { body : null }
    }

    return meta.body?.alarm_type === "entry-event" ? true : false;
  }
  
  parseVideoAIResult(meta){
    if(!meta || typeof meta != 'string') return 'Failed'
    const metaData = JSON.parse(meta)
    const body = metaData?.req?.body
    const entityIds = body?.summary_entity_ids
    if(!entityIds) return 'Failed'

    let cloudResult = ''
    const data = JSON.parse(entityIds)
    const result = Object.values(data)

    let person = ''
    let vehicle = ''
    const isAllPerson = result.every((entity: any[]) => entity?.includes('person'))
    const isAllVehicle = result.every((entity: any[]) => entity?.includes('vehicle'))

    if(data.static?.length) {
      if(data.static.includes('person')) person = 'Stationary Person'
      if(data.static.includes('vehicle')) vehicle = 'Stationary Vehicle'
    }
    if(data.motion?.length) {
      if(data.motion.includes('person')) person = 'Moving Person'
      if(data.motion.includes('vehicle')) vehicle = 'Moving Vehicle'
    }

    if(isAllPerson) person = 'Person'
    if(isAllVehicle) vehicle = 'Vehicle'

    if(person && vehicle) {
      cloudResult = `${person}, ${vehicle}`
    } else if(person || vehicle) {
      cloudResult = `${person || vehicle}`
    } else if(!person && !vehicle) {
      cloudResult = 'Nothing Detected'
    }
    return cloudResult
  }
}
